<template>
  <div class="my-account-wrapper">
    <div class="row">
      <div class="col-12">
        <div class="page__head-title page__head-title--orange">
          <div class="page__head-title__text page__head-title__text--orange">
            Mes documents
          </div>
        </div>
      </div>
      <!-- KBIS -->
      <div class="col-12">
        <div class="form_ttl_first">KBIS :</div>
      </div>
      <div class="col-3">
        <div class="col-12">
          <div class="icon-name-and-contact my-document"></div>
        </div>
        <div class="col-12">
          <label class="custom-filter__inputs--label">
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="kbis.submitted"
                  @click.prevent="onClick"
                />
                <span class="checkboxes__element--text">Soumis</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="kbis.approved"
                  @click.prevent="onClick"
                />
                <span class="checkboxes__element--text">Approuvé</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="kbis.declined"
                  @click.prevent="onClick"
                />
                <span class="checkboxes__element--text">Refusé</span>
              </label>
            </div>
          </label>
        </div>
      </div>

      <div class="col-9">
        <div class="col-12 main-info">
          Les informations concernant votre société
        </div>
        <div class="col-12">
          <button
            class="custom-filter__buttons--button"
            @click="reviewDocs('kbis')"
          >
            {{ kbisButtonLabel }}
          </button>
        </div>
      </div>

      <!-- ORIAS -->
      <div class="col-12">
        <div class="form_ttl_first">ORIAS :</div>
      </div>
      <div class="col-3">
        <div class="col-12">
          <div class="icon-verification-corporate my-document"></div>
        </div>
        <div class="col-12">
          <label class="custom-filter__inputs--label">
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="orias.submitted"
                  @click.prevent="onClick"
                />
                <span class="checkboxes__element--text">Soumis</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="orias.approved"
                  @click.prevent="onClick"
                />
                <span class="checkboxes__element--text">Approuvé</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="orias.declined"
                  @click.prevent="onClick"
                />
                <span class="checkboxes__element--text">Refusé</span>
              </label>
            </div>
          </label>
        </div>
      </div>

      <div class="col-9">
        <div class="col-12 main-info">
          Votre organisme pour le registre unique des intermédiaires en
          assurance
        </div>
        <div class="col-12">
          <button
            class="custom-filter__buttons--button"
            @click="reviewDocs('orias')"
          >
            {{ oriasButtonLabel }}
          </button>
        </div>
      </div>

      <!-- RC -->
      <div class="col-12">
        <div class="form_ttl_first">RC Professionnel :</div>
      </div>
      <div class="col-3">
        <div class="col-12">
          <div class="icon-verification-address my-document"></div>
        </div>
        <div class="col-12">
          <label class="custom-filter__inputs--label">
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="rc.submitted"
                  @click.prevent="onClick"
                />
                <span class="checkboxes__element--text">Soumis</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="rc.approved"
                  @click.prevent="onClick"
                />
                <span class="checkboxes__element--text">Approuvé</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="rc.declined"
                  @click.prevent="onClick"
                />
                <span class="checkboxes__element--text">Refusé</span>
              </label>
            </div>
          </label>
        </div>
      </div>

      <div class="col-9">
        <div class="col-12 main-info">
          Votre assurance Responsabilité Civile Professionnelle
        </div>
        <div class="col-12">
          <button
            class="custom-filter__buttons--button"
            @click="reviewDocs('rc')"
          >
            {{ rcButtonLabel }}
          </button>
        </div>
      </div>

      <!-- RIB -->
      <div class="col-12">
        <div class="form_ttl_first">RIB :</div>
      </div>
      <div class="col-3">
        <div class="col-12">
          <div class="icon-verification-financial my-document"></div>
        </div>
        <div class="col-12">
          <label class="custom-filter__inputs--label">
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="rib.submitted"
                  @click.prevent="onClick"
                />
                <span class="checkboxes__element--text">Soumis</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="rib.approved"
                  @click.prevent="onClick"
                />
                <span class="checkboxes__element--text">Approuvé</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="rib.declined"
                  @click.prevent="onClick"
                />
                <span class="checkboxes__element--text">Refusé</span>
              </label>
            </div>
          </label>
        </div>
      </div>

      <div class="col-9">
        <div class="col-12 main-info">Votre Relevé d’Identité Bancaire</div>
        <div class="col-12">
          <button
            class="custom-filter__buttons--button"
            @click="reviewDocs('rib')"
          >
            {{ ribButtonLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";

export default {
  name: "MyDocumentsRepresentative",
  data() {
    return {
      kbis: {
        submitted: false,
        approved: false,
        declined: false,
      },
      kbisButtonLabel: "Commencer",
      orias: {
        submitted: false,
        approved: false,
        declined: false,
      },
      oriasButtonLabel: "Commencer",
      rc: {
        submitted: false,
        approved: false,
        declined: false,
      },
      rcButtonLabel: "Commencer",
      rib: {
        submitted: false,
        approved: false,
        declined: false,
      },
      ribButtonLabel: "Commencer",
    };
  },
  components: { Multiselect },
  mixins: [validationMixin],
  computed: {
    user() {
      return this.$store.state.userInfo;
    },
  },
  watch: {
    "$store.getters.getAuthUserInfo": function (user) {},
  },
  methods: {
    parseDate(garanty) {
      if (garanty && garanty.created_at) {
        let day = garanty.datesParse.day_created,
          month = garanty.datesParse.month_created,
          year = garanty.datesParse.year_created;
        return day + "/" + month + "/" + year;
      }

      return " - ";
    },
    reviewDocs(type) {
      switch (type) {
        case "kbis":
          this.$router.push("kbis-import");
          break;
        case "orias":
          this.$router.push("orias-import");
          break;
        case "rc":
          this.$router.push("rc-import");
          break;
        case "rib":
          this.$router.push("rib-import");
          break;
      }
    },
    parseUser(documents) {
      if (documents.length > 0) {
        let kbisCanceled = false;
        let oriasCanceled = false;
        let rcCanceled = false;
        let ribCanceled = false;
        for (let i in documents) {
          let doc = documents[i];
          if (doc.type_name === "kbis") {
            if (doc.status !== "approved" && !kbisCanceled) {
              kbisCanceled = true;
            }
            if (doc.status === "submitted") {
              this.kbis.submitted = true;
              this.kbisButtonLabel = "Changer";
            }
            if (doc.status === "approved") {
              this.kbis.approved = this.kbis.submitted = true;
              this.kbisButtonLabel = "Visualiser";
            }
            if (doc.status === "declined") {
              this.kbis.declined = true;
            }
          }
          if (doc.type_name === "orias") {
            if (doc.status !== "approved" && !oriasCanceled) {
              oriasCanceled = true;
            }
            if (doc.status === "submitted") {
              this.orias.submitted = true;
              this.oriasButtonLabel = "Changer";
            }
            if (doc.status === "approved") {
              this.orias.approved = this.orias.submitted = true;
              this.oriasButtonLabel = "Visualiser";
            }
            if (doc.status === "declined") {
              this.orias.declined = true;
            }
          }
          if (doc.type_name === "rc") {
            if (doc.status !== "approved" && !rcCanceled) {
              rcCanceled = true;
            }
            if (doc.status === "submitted") {
              this.rc.submitted = true;
              this.rcButtonLabel = "Changer";
            }
            if (doc.status === "approved") {
              this.rc.approved = this.rc.submitted = true;
              this.rcButtonLabel = "Visualiser";
            }
            if (doc.status === "declined") {
              this.rc.declined = true;
            }
          }
          if (doc.type_name === "rib") {
            if (doc.status !== "approved" && !ribCanceled) {
              ribCanceled = true;
            }
            if (doc.status === "submitted") {
              this.rib.submitted = true;
              this.ribButtonLabel = "Changer";
            }
            if (doc.status === "approved") {
              this.rib.approved = this.rib.submitted = true;
              this.ribButtonLabel = "Visualiser";
            }
            if (doc.status === "declined") {
              this.rib.declined = true;
            }
          }
        }
        if (kbisCanceled) {
          this.kbis.approved = false;
        }
        if (oriasCanceled) {
          this.orias.approved = false;
        }
        if (rcCanceled) {
          this.rc.approved = false;
        }
        if (ribCanceled) {
          this.rib.approved = false;
        }
      }
    },
    onClick() {
      return false;
    },
    getRepresentativeInfo(id) {
      this.isBusy = true;
      let url = `verification_documents/all-documents/${id}`;
      this.apiGet(url)
        .then((response) => {
          this.isBusy = false;
          this.verification_documents = response.data.documents || [];
          this.parseUser(this.verification_documents);
        })
        .catch((error) => {
          this.isBusy = false;
          this.showErrorNotification(error);
        });
    },
  },
  mounted() {
    if (this.user && this.user.representative) {
      this.getRepresentativeInfo(this.user.representative.id);
    }
  },
  validations: {},
};
</script>



// WEBPACK FOOTER //
// src/components/Profile/MyDocumentsRepresentative.vue